// @ts-ignore
export default function (ctx) {
  const $typo3Axios = ctx.$typo3.api.$http;
  const { store, $axios } = ctx;

  $typo3Axios.defaults.trailingSlash = false;
  $axios.defaults.trailingSlash = false;

  $typo3Axios.interceptors.request.use(
    (config: any) => {
      store.commit('axiosLoading/incrementLoading');
      store.commit('axiosLoading/addToCurrentRequests', config.url);
      return config;
    },
    (error: any) => {
      store.commit('axiosLoading/incrementLoading');
      return Promise.reject(error);
    }
  );

  $axios.interceptors.request.use(
    (config: any) => {
      store.commit('axiosLoading/incrementLoading');
      return config;
    },
    (error: any) => {
      store.commit('axiosLoading/incrementLoading');
      return Promise.reject(error);
    }
  );

  $typo3Axios.interceptors.response.use(
    (response: any) => {
      store.commit('axiosLoading/decrementLoading');
      store.commit(
        'axiosLoading/removeFromCurrentRequests',
        response.config.url
      );
      return response;
    },
    (error: any) => {
      store.commit('axiosLoading/decrementLoading');
      return Promise.reject(error);
    }
  );

  $axios.interceptors.response.use(
    (response: any) => {
      store.commit('axiosLoading/decrementLoading');
      return response;
    },
    (error: any) => {
      store.commit('axiosLoading/decrementLoading');
      return Promise.reject(error);
    }
  );
}
